// extracted by mini-css-extract-plugin
module.exports = {"container":"e_vsb","grayStyle":"e_wsb"};